<!--
  Every genre, both kinds — the phone's third bubble, and the screen the desktop
  reaches through a shelf's "All" chip.

  NO ARTWORK. A genre has no poster of its own, so the honest alternatives were a
  grid of 44 network requests for one arbitrary title's backdrop each, or a plate.
  It is a plate: a hue derived from the name, so Comedy is the same colour every
  time you come back and the grid becomes navigable by muscle memory.
-->
<script lang="ts">
  import type { MediaKind } from '$types';
  import { genresFor } from '$lib/ui/cinemeta';
  import { browseHref } from '$lib/ui/nav.svelte';
  import { hue } from '$lib/ui/hue';

  const KINDS: { kind: MediaKind; label: string }[] = [
    { kind: 'movie', label: 'Films' },
    { kind: 'series', label: 'Series' }
  ];

</script>

<svelte:head><title>Categories — Jovii</title></svelte:head>

<div class="page">
  <h1>Categories</h1>
  <p class="lead">Every genre the catalogue actually has, for films and for series.</p>

  {#each KINDS as group (group.kind)}
    <section>
      <h2>{group.label}</h2>
      <div class="grid">
        {#each genresFor(group.kind) as genre (genre)}
          <a class="tile" href={browseHref(group.kind, genre)} style:--h={hue(genre)}>
            <span>{genre}</span>
          </a>
        {/each}
      </div>
    </section>
  {/each}
</div>

<style>
  .page {
    padding: var(--space-5) max(var(--page-pad), var(--safe-r)) var(--space-7)
      max(var(--page-pad), var(--safe-l));
  }
  h1 {
    font-size: var(--text-xl);
    font-weight: var(--weight-bold);
    letter-spacing: var(--tracking-tight);
  }
  .lead {
    margin-top: var(--space-1);
    color: var(--text-dim);
    font-size: var(--text-sm);
  }

  section {
    margin-top: var(--space-6);
  }
  h2 {
    margin-bottom: var(--space-3);
    color: var(--text-faint);
    font-size: var(--text-xs);
    font-weight: var(--weight-semi);
    letter-spacing: var(--tracking-wide);
    text-transform: uppercase;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: var(--space-2);
  }

  .tile {
    display: flex;
    align-items: flex-end;
    min-height: 82px;
    padding: var(--space-3);
    border-radius: var(--radius-lg);
    border: 1px solid var(--glass-line);
    background:
      linear-gradient(140deg, oklch(0.42 0.11 var(--h)) 0%, oklch(0.24 0.06 var(--h)) 62%),
      var(--surface-1);
    box-shadow: var(--glass-shine);
    color: var(--text);
    font-size: var(--text-base);
    font-weight: var(--weight-semi);
    letter-spacing: var(--tracking-snug);
    transition:
      transform var(--dur) var(--ease),
      box-shadow var(--dur) var(--ease);
  }
  .tile:hover {
    transform: translateY(-2px);
    box-shadow: var(--glass-shine), var(--shadow-2);
  }
  .tile:active {
    transform: translateY(0);
  }
</style>
